export const classes = {
  header:
    'w-full flex items-start gap-4 px-6 py-[18px] shrink-0 border-b border-solid border-black/10 bg-gradient-to-b from-white/[0.05] to-transparent dark:border-white/10',
  caseType: 'size-[54px] rounded-[15px]',
  caseTypeIcon: 'size-[26px]',
  infoWrapper: 'flex grow gap-4 min-w-0',
  info: 'min-w-0',
  externalRef: 'text-[11.5px] text-taupe-1 font-mono dark:text-mauve-3',
  nameWrapper: 'flex items-center gap-3 mt-[1px] mb-[7px]',
  name: 'font-bold text-[21px] tracking-[-0.01em] text-taupe-3 dark:text-mauve-1',
  status: 'py-1',
  description: 'mt-2 text-[13px] text-taupe-2 font-normal dark:text-mauve-2',
  leadButton: 'cursor-pointer',
  controls: 'flex items-center gap-1',
  details: 'flex items-center gap-2',
  optionsIcon: 'text-taupe-2 dark:text-mauve-2',
  closeIcon: 'text-taupe-2 dark:text-mauve-2',
};
